import React from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import { getStaticFileUrl } from "../utils/config";

export const TextComponent = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      id="text-269964938"
      sx={{
        width: "100%", // 부모 너비에 맞춤
        height: "55vh",
        textAlign: "center",
        alignItems: "center",
        justifyContent: "center",
        color: "rgb(0, 0, 0)",
        paddingTop: "120px",
        marginBottom: "30px",
        overflow: "hidden", // 넘치는 글자가 보이지 않도록 설정
        backgroundSize: "cover",
        backgroundPosition: "center top",
        backgroundRepeat: "no-repeat",
        backgroundImage: `
        linear-gradient(
          rgba(0, 0, 0, 0.75), 
          rgba(0, 0, 0, 0.75)
        ), 
        url(${getStaticFileUrl('/img/portfolio/banner.png')})
      `,
      }}
    >
              <Box
          component="img"
          src={getStaticFileUrl("/img/logo.png")}
          alt="Logo"
          sx={{
          marginTop: "4rem",
          width: "230px",
          height: "auto",
          marginBottom: "1.5rem",
          "@media (max-width: 960px)": {
            width: "140px",
          },
          "@media (max-width: 600px)": {
            width: "140px",
          },
          animation: "slideUp 0.5s ease-out forwards",
          animationDelay: "0.1s", // 부제목 애니메이션 딜레이
          "@keyframes slideUp": {
            from: {
              transform: "translateY(100%)", // 완전히 안보이는 위치에서 시작
            },
            to: {
              transform: "translateY(0)", // 원래 위치
            },
          },
        }}
      />
      {/* 세로 구분선 */}
      <Box
        sx={{
          width: "1px", // 선 너비
          height: "2.5rem", // 선 높이
          background: "#fff",
          margin: "0 auto 15px", // 중앙 정렬 및 아래 간격
          borderRadius: "2px", // 부드러운 모서리
          animation: "slideUp 0.5s ease-out forwards",
          animationDelay: "0.1s", // 부제목 애니메이션 딜레이
          "@keyframes slideUp": {
            from: {
              transform: "translateY(100%)", // 완전히 안보이는 위치에서 시작
            },
            to: {
              transform: "translateY(0)", // 원래 위치
            },
          },
        }}
      />
      {/* 부제목 */}
      <Box
        sx={{
          overflow: "hidden", // 부제목 애니메이션 영역 제한
        }}
      >
        <Typography
          sx={{
            fontSize: isMobile ? "1.1rem" : "1.5rem", // 부제목 크기
            padding: "10px 0", // 위아래 간격
            color: "#fff",
            fontWeight: "300",
            animation: "slideUp 0.5s ease-out forwards",
            animationDelay: "0.1s", // 부제목 애니메이션 딜레이
            "@keyframes slideUp": {
              from: {
                transform: "translateY(100%)", // 완전히 안보이는 위치에서 시작
              },
              to: {
                transform: "translateY(0)", // 원래 위치
              },
            },
          }}
        >
          POPRTFOLIO
          <br />
          대표적인 성공사례를 공개합니다.
        </Typography>
      </Box>
    </Box>
  );
};
